
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1 9.998a9 9 0 0118 0v6a3 3 0 01-3 3h-6a9 9 0 01-9-9z","fill":"#3C464F"}}),_c('path',{attrs:{"d":"M10.008 13.998c-.361 0-.69-.22-.832-.556l-.752-1.883-1.89-.791c-.455-.204-.659-.73-.455-1.185a.92.92 0 01.486-.47l1.859-.706.745-1.858a.899.899 0 011.654 0l.753 1.866 1.874.745a.893.893 0 01.478 1.176.893.893 0 01-.478.479l-1.874.745-.753 1.866a.896.896 0 01-.831.564h.015v.008z","fill":"#fff"}})])
          )
        }
      }
    